/*
 * @Author: your name
 * @Date: 2019-12-02 12:59:52
 * @LastEditTime: 2020-07-22 18:23:52
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \xqdmall-h5\src\main.js
 */
import Vue from 'vue';
import App from './App.vue';
import router from '@/router/authtoken'
import VueTouch from 'vue-touch'
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
// 配置moment
import  '@/plugins/moment'
Vue.config.productionTip = false
Vue.use(Viewer)
Vue.use(VueTouch, {name:'v-touch'})
VueTouch.config.swipe = { 
  // threshold: 100, //手指左右滑动距离
  direction: "horizontal"//解决无法上下滑动
};
import '@/api/request'


 
// 配置vant
import '@/plugins/vant'
import '@/styles/vant.scss'
// 自定义指令
import '@/util/directives'
// 过滤器
import '@/util/filters'
// 


new Vue({
  render: h => h(App),
  router
}).$mount('#app')